import { setLoadingConfigObject } from '../../Shimmer/Shimmer.utils';

import styles from './VFBannerLoading.config.style';

const VFBannerLoadingConfig = [
  {
    left: setLoadingConfigObject('circle', 1, 18, styles.icon),
    main: setLoadingConfigObject('square', 1, null, styles.title),
  },
  {
    left: [
      setLoadingConfigObject('square', 1, null, styles.desc1),
      setLoadingConfigObject('square', 1, null, styles.desc2),
    ],
  },
  {
    main: setLoadingConfigObject('square', 1, null, styles.btn),
  },
];

export { VFBannerLoadingConfig };
